module.exports = __webpack_public_path__ + "img/20190703152904629.c6fb82ad.png";